<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">

            <div class="d-sm-flex gap-1 align-items-center mb-4">
              <h5
                class="card-title fw-semibold mb-3 mb-sm-0 me-auto"
              >{{title}} {{type == 'admin' ? 'User Administrator' : 'Responden'}}</h5>
              <template v-if="type == 'responden' && userId != ''">
                <router-link
                  :to="`/message?userId=${userId}`"
                  class="btn btn btn-outline-success mb-1 mb-sm-0"
                >Pesan</router-link>
                <router-link
                  :to="`/user-schedules?userId=${userId}`"
                  class="btn btn btn-outline-success mb-1 mb-sm-0"
                >Penjadwalan</router-link>
                <router-link
                  :to="`/psychology?userId=${userId}`"
                  class="btn btn btn-outline-success mb-1 mb-sm-0"
                >Kondisi Kejiwaan</router-link>

                <div class="dropdown d-inline-block">
                  <a
                    class="btn btn-primary dropdown-toggle mb-1 mb-sm-0"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >Kelola</a>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <router-link
                        class="dropdown-item"
                        :to="`user-examination?userId=${userId}`"
                      >Riwayat Pemeriksaan</router-link>
                    </li>
                    <li>
                      <router-link
                        class="dropdown-item"
                        :to="`user-pregnancies?userId=${userId}`"
                      >Daftar Profil Kehamilan</router-link>
                    </li>
                    <li>
                      <router-link
                        class="dropdown-item"
                        :to="`user-assessment?userId=${userId}`"
                      >Assessment</router-link>
                    </li>
                    <li>
                      <router-link
                        class="dropdown-item"
                        :to="`report?userId=${userId}`"
                      >Laporan</router-link>
                    </li>
                    <li>
                      <hr class="my-2">
                    </li>
                    <li>
                      <router-link
                        class="dropdown-item"
                        :to="`form-examination?userId=${userId}`"
                      >Tambah Pemeriksaan</router-link>
                    </li>
                    <li>
                      <router-link
                        class="dropdown-item"
                        :to="`form-maternity?userId=${userId}`"
                      >Tambah Profil Kehamilan</router-link>
                    </li>
                  </ul>
                </div>
              </template>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <div class="row g-4">
              <div class="col-sm-7 col-lg-8 order-2 order-sm-1">
                <ul class="nav nav-pills mb-4 gap-1" id="pills-tab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="pills-0-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-0"
                      type="button"
                      role="tab"
                      aria-controls="pills-0"
                      aria-selected="true"
                    >Informasi Diri</button>
                  </li>
                  <li
                    v-if="countKehamilan == 0 && userId != ''"
                    class="nav-item"
                    role="presentation"
                  >
                    <button
                      class="nav-link"
                      id="pills-3-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-3"
                      type="button"
                      role="tab"
                      aria-controls="pills-3"
                      aria-selected="false"
                    >Profil Kehamilan</button>
                  </li>
                  <li
                    v-if="type == 'responden' && userId != ''"
                    class="nav-item"
                    role="presentation"
                  >
                    <button
                      class="nav-link"
                      id="pills-4-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-4"
                      type="button"
                      role="tab"
                      aria-controls="pills-4"
                      aria-selected="false"
                    >Kondisi Kejiwaan</button>
                  </li>
                </ul>

                <div class="tab-content" id="pills-tabContent">
                  <div
                    class="tab-pane fade show active"
                    id="pills-0"
                    role="tabpanel"
                    aria-labelledby="pills-0-tab"
                    tabindex="0"
                  >
                    <form @submit.prevent="onSubmit">
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Nama Lengkap *</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            v-model="form.fullname"
                            class="form-control"
                            placeholder="Nama Lengkap..."
                            autocomplete="off"
                            required
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">NIK / Nomor Penduduk *</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            v-model="form.nik"
                            class="form-control"
                            placeholder="NIK / Nomor Penduduk..."
                            autocomplete="off"
                            required
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Tanggal Lahir</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="date"
                            v-model="form.birth_date"
                            class="form-control"
                            value
                            placeholder="Tanggal Lahir..."
                            autocomplete="off"
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Jenis Kelamin *</label>
                        </div>
                        <div class="col-lg-8">
                          <div class="form-check form-check-inline">
                            <input
                              v-model="form.gender"
                              class="form-check-input"
                              type="radio"
                              name="gender"
                              id="inlineRadio1"
                              value="male"
                              autocomplete="off"
                              required
                            >
                            <label class="form-check-label" for="inlineRadio1">Pria</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input
                              v-model="form.gender"
                              class="form-check-input"
                              type="radio"
                              name="gender"
                              id="inlineRadio2"
                              value="female"
                              autocomplete="off"
                            >
                            <label class="form-check-label" for="inlineRadio2">Wanita</label>
                          </div>
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Usia</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            v-model="usia"
                            type="number"
                            class="form-control"
                            placeholder="Usia..."
                            min="1"
                            max="200"
                            autocomplete="off"
                            disabled
                          >
                        </div>
                      </div>

                      <hr class="border-0 pt-1 bg-dark rounded my-4">

                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Alamat</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            v-model="form.address"
                            class="form-control"
                            placeholder="Alamat..."
                            autocomplete="off"
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Provinsi</label>
                        </div>
                        <div class="col-lg-8">
                          <select
                            v-model="form.province"
                            @change="getCity()"
                            type="text"
                            class="form-select"
                          >
                            <option value disabled hidden>--- Pilih ---</option>
                            <option
                              v-for="(item,i) in provinceList"
                              :value="item.name"
                              :key="`p${i}`"
                            >{{ item.name }}</option>
                          </select>

                          <!-- <input
                            type="text"
                            id
                            class="form-control"
                            value
                            placeholder="Provinsi..."
                            autocomplete="off"
                          >-->
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Kota</label>
                        </div>
                        <div class="col-lg-8">
                          <select v-model="form.city" type="text" class="form-select">
                            <option value disabled hidden>--- Pilih ---</option>
                            <option
                              v-for="(item,it) in cityList"
                              :value="item.name"
                              :key="`ct${it}`"
                            >{{ item.name }}</option>
                          </select>
                          <!-- <input
                            type="text"
                            id
                            class="form-control"
                            value
                            placeholder="Kota..."
                            autocomplete="off"
                          >-->
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Kode Pos</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="number"
                            v-model="form.postal_code"
                            class="form-control"
                            placeholder="Kode Pos..."
                            autocomplete="off"
                          >
                        </div>
                      </div>

                      <hr class="border-0 pt-1 bg-dark rounded my-4">

                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Alamat Email *</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="email"
                            v-model="form.email"
                            class="form-control"
                            placeholder="Alamat Email..."
                            autocomplete="off"
                            required
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Nomor Telepon *</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="number"
                            v-model="form.telp"
                            class="form-control"
                            placeholder="Nomor Telepon..."
                            min="0"
                            autocomplete="off"
                            required
                          >
                        </div>
                      </div>
                      <div v-if="type == 'admin'" class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Role Akun *</label>
                        </div>
                        <div class="col-lg-8">
                          <select v-model="form.type" type="text" id class="form-select" required>
                            <option value>--- Pilih ---</option>
                            <option value="doctor">Dokter</option>
                            <option value="nurse">Perawat</option>
                            <option value="admin">Admin</option>
                          </select>
                        </div>
                      </div>
                      <button type="submit" class="btn btn-primary mt-4">{{button}} Informasi Diri</button>
                    </form>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="pills-4"
                    role="tabpanel"
                    aria-labelledby="pills-4-tab"
                    tabindex="0"
                  >
                    <form @submit.prevent="onSubmitKejiwaan">

                    <div class="table-responsive">
                      <table class="table table-striped align-middle">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Pertanyaan</th>
                            <th scope="col">Jawaban</th>
                            <th class="text-center" scope="col">Skor</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(req, idx) in latestItems" :key="idx">
                            <th scope="row">{{ idx + 1 }}</th>
                            <td>{{req.question}}</td>
                            <td>
                              {{ req.answer || '-'}}
                              <!-- <?php if($row['input_type'] === 'radio') { ?>
                                <?php foreach($row['option_value'] as $skey=>$val) { ?>
                                  <div class="form-check mb-2">
                                    <input name="value[][<?php print $row['question_text']; ?>]" type="radio" class="form-check-input" id="exampleRadio_<?php print $key.'_'.$skey; ?>" autocomplete="off">
                                    <label class="form-check-label" for="exampleRadio_<?php print $key.'_'.$skey; ?>"><?php print $val; ?></label>
                                  </div>
                                <?php } ?>
                                
                              <?php } elseif($row['input_type'] === 'checkbox') { ?>
                                <?php foreach($row['option_value'] as $skey=>$val) { ?>
                                  <div class="form-check mb-2">
                                    <input name="value[][<?php print $row['question_text']; ?>]" type="checkbox" class="form-check-input" id="exampleCheck_<?php print $key.'_'.$skey; ?>" autocomplete="off">
                                    <label class="form-check-label" for="exampleCheck_<?php print $key.'_'.$skey; ?>"><?php print $val; ?></label>
                                  </div>
                                <?php } ?>

                              <?php } elseif($row['input_type'] === 'textarea') { ?>
                                <div class="mb-2">
                                  <textarea name="value[][<?php print $row['question_text']; ?>]" class="form-control form-control-sm bg-light fw-bold" id="exampleFormControlTextarea_<?php print $key; ?>" placeholder="Hasil..." rows="3" autocomplete="off"></textarea>
                                </div>

                              <?php } elseif($row['input_type'] === 'text') { ?>
                                <div class="mb-2">
                                  <input type="text" name="value[][<?php print $row['question_text']; ?>]" class="form-control form-control-sm bg-light fw-bold mx-auto" id="exampleFormControlText_<?php print $key; ?>" placeholder="Hasil..." autocomplete="off" />
                                </div>
                              <?php } ?>-->
                            </td>
                            <td class="text-center">
                              <div class="mb-2">
                                <input
                                  v-model="req.score"
                                  type="text"
                                  class="form-control form-control-sm bg-light fw-bold mx-auto"
                                  placeholder="Hasil..."
                                  autocomplete="off"
                                  disabled
                                >
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                      <!-- <button type="submit" class="btn btn-primary mt-4">Simpan</button> -->
                  </form>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="pills-3"
                    role="tabpanel"
                    aria-labelledby="pills-3-tab"
                    tabindex="0"
                  >
                    <form @submit.prevent="onSubmit3">
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Nama Kehamilan *</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            v-model="form3.profile"
                            class="form-control"
                            placeholder="Nama Kehamilan..."
                            autocomplete="off"
                            required
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Deskripsi</label>
                        </div>
                        <div class="col-lg-8">
                          <textarea
                            v-model="form3.description"
                            class="form-control"
                            placeholder="Deskripsi..."
                            rows="3"
                            autocomplete="off"
                          ></textarea>
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">HPHT *</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="date"
                            v-model="form3.hpht"
                            class="form-control"
                            placeholder="HPHT..."
                            autocomplete="off"
                            required
                          >
                        </div>
                      </div>


                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">HPL</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            v-model="hpl"
                            type="date"
                            class="form-control"
                            placeholder="HPL..."
                            autocomplete="off"
                            disabled
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Usia Kehamilan</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            v-model="usiaKehamilan"
                            class="form-control"
                            placeholder="Usia Kehamilan..."
                            autocomplete="off"
                            disabled
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">BB Sebelum Kehamilan *</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            v-model="form3.pre_pregnancy_weight"
                            class="form-control"
                            placeholder="BB Sebelum Kehamilan..."
                            autocomplete="off"
                            required
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Tahun Kelahiran Sebelumnya</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="number"
                            v-model="form3.obstetric_history"
                            class="form-control"
                            placeholder="Tahun Kelahiran Sebelumnya..."
                            min="1000"
                            max="3000"
                            autocomplete="off"
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Jumlah Pernah Cesarean</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="number"
                            v-model="form3.cesarean_count"
                            class="form-control"
                            placeholder="Jumlah Pernah Cesarean..."
                            min="0"
                            max="100"
                            autocomplete="off"
                          >
                        </div>
                      </div>
                      <div class="row g-0 g-lg-3 align-items-center mb-3">
                        <div class="col-lg-4">
                          <label for class="col-form-label">Riwayat Kesehatan</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            v-model="form3.medical_history"
                            class="form-control"
                            placeholder="Riwayat Kesehatan..."
                            autocomplete="off"
                          >
                        </div>
                      </div>
                      <button type="submit" class="btn btn-primary mt-4">Simpan Profil Kehamilan</button>
                    </form>
                  </div>

                  <!-- ================================== -->
                  <!-- form kejiwaan -->
                  <!-- ================================== -->
                </div>
              </div>

              <div v-if="userId" class="col-sm-5 col-lg-3 order-1 order-sm-2">
                <div class="bg-success-subtle rounded-4 p-2 shadow-sm mb-3 text-center">
                  <img
                    v-if="preview != ''"
                    :src="preview"
                    alt="preview"
                    class="img-fluid rounded-3"
                  >
                  <img
                    v-else-if="preview == ''"
                    src="../assets/images/profile/user-7.jpg"
                    class="img-fluid rounded-3"
                    alt="no-img"
                  >
                  <img v-else :src="preview" alt="preview" class="img-fluid rounded-3">
                </div>

                <button @click="triggerFileInput" class="btn btn-success w-100 rounded">Upload Image</button>
                <input type="file" @change="onFileChange" ref="fileInput" style="display: none">
              </div>
            </div>

            <!-- <button
              type="submit"
              href="detail-examination.php"
              class="btn btn-primary mt-4 "
            >Simpan</button>-->
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'
import config from "../config";

export default {
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			page: 1,
			pageSize: 30,
			pageSizes: [10, 20, 50],
			token: localStorage.getItem('token'),
			form: {
				// id: '',
				fullname: '',
				name: '',
				type: 'nurse',
				email: '',
				password: '',
				birth_date: '1990-12-30',
				telp: '',
				gender: 'female',
				roleId: 3,
				statusId: 1,
				nik: '',
				place_date: '',
				address: '',
				city: '',
				province: '',
				country: 'ID',
				religion: '',
				specialization: '',
				licence_number: ''
			},
			form3: {
				profile: '',
				description: '',
				hpht: '',
				pre_pregnancy_weight: '',
				obstetric_history: '',
				cesarean_count: '',
				medical_history: '',
				statusId: 11
			},
			file: null,
			// preview: '',
			title: 'Tambah',
			button: 'Simpan',
			url: 'users/add',
			url2: 'user_spesialized/',
			method: 'post',
			countSpesial: 0,
			countKehamilan: 0
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
		this.$store.dispatch('location/getDataThird', {
			url: `datasheet/provinces`
		})

		if (this.userId) {
			this.$store.dispatch('location/getDataPayload4', {
				url: `user_assessment/all/${this.userId}`,
				params: {
					section: 'Pertanyaan Kejiwaan',
					userId: this.userId,
					offset: this.page - 1,
					limit: this.pageSize,
					order: this.order
				}
			})
		}
	},
	beforeRouteUpdate(to, from, next) {
		this.form = {
			// id: '',
			fullname: '',
			name: '',
			type: 'nurse',
			email: '',
			password: '',
			birth_date: '1990-12-30',
			telp: '',
			gender: 'female',
			roleId: 3,
			statusId: 1,
			nik: '',
			place_date: '',
			address: '',
			city: '',
			province: '',
			country: 'ID',
			religion: '',
			specialization: '',
			licence_number: ''
		}

		;(this.title = 'Tambah'), (this.button = 'Simpan'), (this.url = 'users/add'), (this.url2 = 'user_spesialized/'), (this.method = 'post')

		next()
	},
	mounted() {
		if (this.userId) {
			this.title = 'Update'
			this.button = 'Update'
			this.method = 'PUT'
			this.$store
				.dispatch('location/getDataPayload', {
					url: `users/${this.userId}`
				})
				.then((res) => {
					console.log('respon->>', res)

					this.form = {
						// id: this.dataUser.id,
						fullname: this.dataUser.user_profile.fullname,
						type: this.dataUser.type,
						email: this.dataUser.email,
						// email: res.payload.email,
						// password: this.dataUser.user_profile.,
						birth_date: this.dataUser.user_profile.birth_date,

						postal_code: this.dataUser.user_profile.postal_code,
						gender: this.dataUser.user_profile.gender,
						telp: this.dataUser.user_profile.telp,
						roleId: this.dataUser.roleId,
						statusId: this.dataUser.statusId,
						nik: this.dataUser.user_profile.nik,
						place_date: this.dataUser.user_profile.place_date,
						address: this.dataUser.user_profile.address,
						city: this.dataUser.user_profile.city,
						province: this.dataUser.user_profile.province,
						country: 'ID',
						religion: this.dataUser.user_profile.religion,
						specialization: this.dataUser.user_profile.specialization,
						licence_number: this.dataUser.user_profile.licence_number
					}
					if (this.form.province != 'undefined' && this.form.province != '' && this.form.province != null) {
						this.getCity()
					}
				})

			this.$store
				.dispatch('location/getDataPayload3', {
					url: `user_pregnancies`,
					params: {
						userId: this.userId
						// offset: this.page - 1,
						// limit: this.pageSize,
						// order: this.order
					}
				})
				.then((res) => {
					console.log('respon spea->>', res)
					this.countKehamilan = res.count

					// if (res.payload.Records != null) {
					// 	this.form2 = res.payload.Records
					// }
				})
		}
	},
	computed: {
		...mapGetters({
			dataKejiwaan: 'location/getDataPayload4',
			dataUser: 'location/getDataPayload',
			dataSpeali: 'location/getDataPayload3',
			provinceList: 'location/getDataThird',
			cityList: 'location/getDataPayload2'
		}),
		latestDate() {
			const payload = this.payload || this.dataKejiwaan
			if (!payload || typeof payload !== 'object') return null
			const dates = Object.keys(payload)
			if (!dates.length) return null
			dates.sort((a, b) => b.localeCompare(a))
			return dates[0]
		},
		latestItems() {
			if (!this.latestDate) return []
			return (this.payload || this.dataKejiwaan)[this.latestDate] || []
		},
		latestEntry() {
			// optional: single latest entry by timestamp
			const payload = this.payload || this.dataKejiwaan
			if (!payload) return null
			const all = [].concat(...Object.values(payload)) // safe flatten
			if (!all.length) return null
			return all.reduce((latest, cur) => {
				if (!latest) return cur
				return new Date(cur.assessment_date) > new Date(latest.assessment_date) ? cur : latest
			}, null)
		},
		preview: {
			// getter
			get() {
				let url = ''
				if (this.dataUser && this.dataUser.user_profile) {
					if (this.dataUser.user_profile.attachment === null || this.dataUser.user_profile.attachment === 'null' || this.dataUser.user_profile.attachment === undefined || this.dataUser.user_profile.attachment === 'undefined' || this.dataUser.user_profile.attachment === '') {
					} else {
						url = config("api.baseUrl") + 'storage/uploads/' + this.dataUser.user_profile.attachment
					}
				} else {
				}
				return url
			},
			set(value) {
				this.dataUser.user_profile.attachment = value
			}
		},
		usia: {
			// getter
			get() {
				return this.hitungUsia(this.form.birth_date)
			}
		},
		hpl: {
			// getter
			get() {
				return this.hitungHplDanUsia(this.form3.hpht).hpl
			}
		},
		usiaKehamilan: {
			// getter
			get() {
				return this.hitungHplDanUsia(this.form3.hpht).usiaMinggu
			}
		},
		userId: {
			// getter
			get() {
				return this.$route.query.userId || ''
			}
		},
		idSpesial: {
			// getter
			get() {
				return this.form2.id || ''
			}
		},
		type: {
			// getter
			get() {
				return this.$route.query.type || 'admin'
			}
		}
	},
	methods: {
		triggerFileInput() {
			this.$refs.fileInput.click() // klik input file tersembunyi
		},
		// upload khusus update user
		onFileChange(e) {
			const file = e.target.files[0]
			if (file) {
				this.file = file
				// this.preview = URL.createObjectURL(file) // buat preview gambar

				let formData = new FormData()
				formData.append('image', this.file)
				this.$store.dispatch('location/upload', formData).then((res) => {
					// this.storeData(res.filename)
					console.log('res dari api set img==>', res)
					this.preview = res.filename
					this.form.attachment = res.filename
					this.form.name = this.form.fullname
					this.$store
						.dispatch('location/createNewRecord', {
							data: this.form,
							url: 'users/update/' + this.userId,
							method: 'PUT'
						})
						.then((res) => {
							console.log(res)
							let toast = this.$toasted.show(`${res.msg}`, {
								theme: 'bubble',
								position: 'top-right',
								duration: 3000
							})
						})
				})
			}

			// if (!this.file) {
			// 	alert('Pilih gambar dulu!')
			// 	return
			// }
		},
		getCity() {
			this.$store.dispatch('location/getDataPayload2', {
				url: `datasheet/cities/${this.form.province}`
			})
		},
		onSubmit() {
			if (this.userId != '') {
				this.url = 'users/update/' + this.userId
				this.method = 'PUT'
			}

			if (this.type == 'responden') {
				this.form.type = 'patient'
				this.form.roleId = 1
			}

			this.form.name = this.form.fullname
			this.$store
				.dispatch('location/createNewRecord', {
					data: this.form,
					url: this.url,
					method: this.method
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.form.id = res.payload.id
						if (this.type == 'admin') {
							if (this.userId != '') {
							} else {
								this.$router.push('/user')
							}
						} else {
							this.$router.push('/responden')
							// this.$router.push('/form-user?type=responden&userId=' + res.payload.id)
						}
						// this.form = {
						// 	id: '',
						// 	fullname: '',
						// 	type: 'nurse',
						// 	email: '',
						// 	password: '',
						// 	birth_date: '2025-12-12',
						// 	telp: '',
						// 	roleId: 3,
						// 	statusId: 1,
						// 	nik: '',
						// 	place_date: '',
						// 	address: '',
						// 	city: '',
						// 	province: '',
						// 	country: 'ID',
						// 	religion: '',
						// 	specialization: '',
						// 	licence_number: ''
						// }
					} else {
					}
				})
		},
		onSubmit3() {
			if (this.userId != '') {
				this.method = 'PUT'
			}

			this.form3.hpl = this.hpl
			this.$store
				.dispatch('location/createNewRecord', {
					data: this.form3,
					url: 'user_pregnancies/' + this.userId,
					method: 'POST'
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.countKehamilan = 1
						this.$router.push('/user-pregnancies?userId=' + this.userId)
					} else {
					}
				})
		},
		onSubmitKejiwaan() {
			this.$store
				.dispatch('location/createNewRecord', {
					data: {records : this.latestItems},
					url: 'user_assessment/update',
					method: 'PUT'
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.$router.push('/psychology?userId=' + this.userId)
					} else {
					}
				})
		},
		hitungUsia(tanggalLahir) {
			const today = new Date()
			const birthDate = new Date(tanggalLahir)
			let age = today.getFullYear() - birthDate.getFullYear()
			const m = today.getMonth() - birthDate.getMonth()

			// kalau bulan belum lewat, atau bulan sama tapi hari belum lewat → usia dikurangi 1
			if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
				age--
			}

			return age
		},
		hitungHplDanUsia(hpht) {
			const hphtDate = new Date(hpht)
			if (isNaN(hphtDate)) {
				return { error: 'Format tanggal salah (gunakan YYYY-MM-DD)' }
			}

			// --- HPL (HPHT + 280 hari) ---
			const hplDate = new Date(hphtDate)
			hplDate.setDate(hplDate.getDate() + 280)

			// --- Usia Kehamilan ---
			const today = new Date()
			let diffMs = today - hphtDate // selisih dalam ms
			if (diffMs < 0) {
				return { error: 'HPHT tidak boleh setelah hari ini' }
			}

			let usiaHari = Math.floor(diffMs / (1000 * 60 * 60 * 24))
			let usiaMinggu = Math.floor(usiaHari / 7)
			let sisaHari = usiaHari % 7

			return {
				hpl: hplDate.toISOString().split('T')[0], // format YYYY-MM-DD
				usiaHari,
				usiaMinggu,
				keterangan: `${usiaMinggu} minggu ${sisaHari} hari`
			}
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
